module.exports = __webpack_public_path__ + "assets/img/ptp10.f3fc0b44.png";